import TwinIcon from '../../../TwinIcon'
import UserIcons from './UserIcons'
import { Routes } from '../../../CreateRoutering/types'
import { faBars } from '@fortawesome/pro-solid-svg-icons'
import { ModalOpenedSetTy, ModalOpenedTy } from '../../../Modal/types'
import { LeftMenuPrintItemsConnect, LeftMenuPrintItemsNew1Connect } from '../LeftMenuComponents'
import { BookMarkRoute, BookMarkRoutesParsedTy } from '../../../../app/erp/types'
import { Link } from 'react-router-dom'

interface IconMenuBarProps {
    routes: Routes
    opened: ModalOpenedTy
    setOpened: ModalOpenedSetTy
    onClick: () => void
}

const IconMenuBar: React.FC<IconMenuBarProps> = ({ routes, opened, setOpened, onClick }) => {
    return (
        <div className='w-70 flex flex-col items-center bg-gray-33 py-15 z-3 overflow-auto'>
            {!opened ? <TwinIcon icon={faBars} className={'cursor-pointer text-white opacity-50 pt-12 h-27'} onClick={() => setOpened(true)} /> : <Link to='/'>
                <img className='menu_bar_logo' src='/logo-white.png' alt='' />
            </Link>}
            <LeftMenuPrintItemsConnect routes={routes} bookMarkParsed={[]} bookMarkParsedDict={undefined}/>
            <UserIcons onClick={onClick} routes={routes} />
        </div>
    )
}

interface IconMenuBarNew1Props {
    routes: Routes
    bookMarkParsed: BookMarkRoute[]
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}

export const IconMenuBarNew1: React.FC<IconMenuBarNew1Props> = ({ routes, bookMarkParsed, bookMarkParsedDict }) => {
    return (
        <div className='w-70 flex flex-col items-center bg-gray-33 py-15 z-3'>
            <Link to='/'>
                <img className='menu_bar_logo' src='/logo-white.png' alt='' />
            </Link>
            <LeftMenuPrintItemsNew1Connect routes={routes} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkParsedDict}/>
        </div>
    )
}

export default IconMenuBar